import { datadogRum } from '@datadog/browser-rum';
import type { ErrorInfo, PropsWithChildren, ReactNode } from 'react';
import { Component } from 'react';
import { type WithTranslation, withTranslation } from 'react-i18next';
import type { TFunction } from 'i18next';
import GeneralError from './GeneralError';

interface State {
  error?: Error;
  errorInfo?: ErrorInfo;
}

interface IProps extends WithTranslation, PropsWithChildren {
  t: TFunction;
}

interface IState {
  error?: Error;
  errorInfo?: ErrorInfo;
}

class ErrorBoundary extends Component<IProps, IState> {
  public state: State = {
    error: undefined,
    errorInfo: undefined,
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { error: error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error({ error, errorInfo });
    datadogRum.addError(error, {
      errorBoundary: true,
      componentStack: errorInfo.componentStack,
    });
    this.setState({ error, errorInfo });
  }

  public render(): ReactNode {
    if (this.state.error) {
      return (
        <GeneralError
          error={this.state.error}
          title={this.props.t('karwa.error_ui.sorry_there_was_an_error')}
        />
      );
    }
    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
